import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useModal } from 'mui-modal-provider';
import { useQuery } from '@apollo/client';

import { ReferralModalRegistration } from './referral-modal-registration';
import { refIdFromParams, getRefMyAcuvueId } from '../../../../utils';
import { useEnterPromoCode } from '../../../../hooks';
import { GET_IS_USER_LOGGED_IN } from '../../../../graphql';
import { useLogout } from '../../../../graphql/user/actions/logout';

export const ReferralModalHandler = (): null => {
  const location = useLocation();
  const { showModal } = useModal();
  const { registerPromoCode } = useEnterPromoCode();
  const { logout } = useLogout();
  const { data: { user: { isLoggedIn } } } = useQuery(GET_IS_USER_LOGGED_IN);

  useEffect(() => {
    // Read refMyAcuvueId from URL search params, show modal in Registration flow
    const refId = refIdFromParams();
    if (refId && location.pathname === '/registration') {
      if (isLoggedIn) {
        logout();
        return;
      }

      showModal(ReferralModalRegistration, {});
      return;
    }

    // Read refMyAcuvueId from localStorAge, send promo code
    const refIdFromStorage = getRefMyAcuvueId();
    if (isLoggedIn && refIdFromStorage) {
      registerPromoCode(refIdFromStorage, true);
    }
  }, []);

  return null;
};
